import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/main.scss';
import i18n from './i18n';
import { initAuth, login } from './auth/keycloak';
import { App } from './App';

// GOV.UK/ID-SK styles for enhanced components depend on this class (the template sets it with an inline script,
// which the Content-Security-Policy does not allow).
document.body.classList.add('js-enabled');

const container = document.getElementById('root')!;
const root = createRoot(container);

function renderStatus(key: string) {
  root.render(
    <div className="govuk-width-container">
      <main className="govuk-main-wrapper" id="main-content">
        <p className="govuk-body" role="status">
          {i18n.t(key)}
        </p>
      </main>
    </div>,
  );
}

renderStatus('auth.signingIn');

initAuth()
  .then(async (authenticated) => {
    if (!authenticated) {
      await login();
      return;
    }
    root.render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  })
  .catch(() => renderStatus('auth.unavailable'));
